module.exports = __webpack_public_path__ + "static/media/Bip.0601a26f.mp3";